/* @flow */
import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { listCardFactory } from './ListCard';
import { IconButton } from 'react-toolbox/lib/button';
import NumberUtils from 'common/utils/NumberUtils';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';

import theme from './MapAddressCard.scss';

const Subtitles = ({ subtitles, theme }) => {
    return (
        <div className={theme.subtitles}>
            {subtitles.map((subtitle, index) => (
                <div key={index} className={theme.subtitle}>
                    {subtitle}
                </div>
            ))}
        </div>
    );
};
const RightActions = ({ rightActions, theme }) => {
    return (
        <div className={theme.right}>
            {Object.keys(rightActions).map((key, index) => {
                return (
                    <IconButton
                        key={index}
                        theme={theme}
                        icon={<MlFontIcon iconClass={rightActions[key].icon} />}
                        onClick={rightActions[key].onClick}
                    />
                );
            })}
        </div>
    );
};

const ListCard = listCardFactory({
    Subtitle: Subtitles,
    RightIcon: RightActions
});

const defaults = {
    theme: {}
};

const mapAddressCardFactory = (options = {}) => {
    const { theme: defaultTheme } = { ...defaults, ...options };

    return () => {
        class MapAddressCardComponent extends Component {
            constructor(props) {
                super(props);
                this.handleClick = this.handleClick.bind(this);
            }

            handleClick(event) {
                if (this.props.onClick && !this.props.disabled) {
                    this.props.onClick(event);
                }
            }

            render() {
                const {
                    theme,
                    addressTitle,
                    addressSubtitle,
                    markerIndex,
                    latLng,
                    markerColor,
                    addressActions
                } = this.props;
                return (
                    <ListCard
                        title={addressTitle}
                        subtitles={[addressSubtitle, latLng]}
                        leftNumber={NumberUtils.padLeft(markerIndex)}
                        leftIconBgColor={markerColor}
                        rightActions={addressActions}
                        theme={theme}
                    />
                );
            }
        }
        return themr('MapAddressCard', defaultTheme)(MapAddressCardComponent);
    };
};

const themedMapAddressCardFactory = options =>
    mapAddressCardFactory({ ...options, theme });

const themedFactory = mapAddressCardFactory({ theme });
const MapAddressCard = themedFactory({});

export default MapAddressCard;
export { MapAddressCard, themedMapAddressCardFactory as mapAddressCardFactory };
